import { useState } from "react";
import { ChevronDown } from "lucide-react";

export default function FaqBlock({ faqs = [], testId = "faq" }) {
  const [open, setOpen] = useState(0);
  if (!faqs.length) return null;
  return (
    <div className="divide-y divide-white/5" data-testid={testId}>
      {faqs.map((f, i) => {
        const isOpen = i === open;
        return (
          <div key={`${i}-${f.q}`}>
            <button
              type="button"
              onClick={() => setOpen(isOpen ? -1 : i)}
              data-testid={`${testId}-item-${i}`}
              className="w-full flex items-center justify-between gap-4 text-left px-5 sm:px-6 py-5 hover:bg-white/[0.02] transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow-400"
              aria-expanded={isOpen}
            >
              <span className="font-display font-black uppercase text-white text-base sm:text-lg tracking-tight">
                {f.q}
              </span>
              <ChevronDown
                className={`h-5 w-5 text-yellow-400 shrink-0 transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
                strokeWidth={2.5}
              />
            </button>
            {isOpen && (
              <div className="px-5 sm:px-6 pb-6 pt-1 text-zinc-300 text-sm leading-relaxed font-light">
                {f.a}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
